// Os campos de indicador sao texto livre ("R$ 1,24M", "99,94%", "3,2d"), o que
// e otimo para escrever e ruim para calcular. Estes helpers extraem o numero
// quando da, e desistem em silencio quando nao da - nunca mostramos conta que
// nao temos certeza de ter lido certo.

const SUFIXOS = [
  { teste: /^(k|mil)$/i, fator: 1e3 },
  { teste: /^(m|mi|mm|milhao|milhoes|milhão|milhões)$/i, fator: 1e6 },
  { teste: /^(b|bi|bilhao|bilhoes|bilhão|bilhões)$/i, fator: 1e9 },
];

/**
 * Le o primeiro numero de um texto de indicador.
 * Devolve null quando nao ha numero reconhecivel.
 */
export function parseValorNumerico(texto) {
  if (texto === null || texto === undefined) return null;

  const bruto = String(texto).trim();
  if (!bruto) return null;

  // Pega o primeiro numero e o que vem colado depois dele (a unidade).
  const casa = bruto.match(/(-?[\d.,]+)\s*([a-zA-Zçãõ%]*)/);
  if (!casa) return null;

  let numero = casa[1];
  const unidade = casa[2] || "";

  // Convencao pt-BR: se ha virgula, ela e o decimal e os pontos sao milhar.
  // Sem virgula, o ponto vale como decimal (aceita quem digita "3.2").
  if (numero.includes(",")) {
    numero = numero.replace(/\./g, "").replace(",", ".");
  }

  const valor = Number.parseFloat(numero);
  if (Number.isNaN(valor)) return null;

  const sufixo = SUFIXOS.find((item) => item.teste.test(unidade));
  return sufixo ? valor * sufixo.fator : valor;
}

/**
 * Atingimento em % (valor sobre meta).
 *
 * Deliberadamente sem juizo de valor: para indicadores em que menos e melhor
 * (burn, churn, lead time) "120%" e ruim, e o sistema ainda nao sabe a direcao
 * de cada indicador. Por isso quem exibe mostra em cinza, sem cor.
 */
export function calcularAtingimento(valor, meta) {
  const atual = parseValorNumerico(valor);
  const alvo = parseValorNumerico(meta);

  if (atual === null || alvo === null || alvo === 0) return null;

  return Math.round((atual / alvo) * 100);
}

/**
 * Variacao percentual contra a semana anterior.
 *
 * Percentual e nao absoluto de proposito: funciona igual para "1,24M" e para
 * "3,2d", sem precisar saber a escala nem a unidade.
 */
export function calcularVariacao(valorAtual, valorAnterior) {
  const atual = parseValorNumerico(valorAtual);
  const anterior = parseValorNumerico(valorAnterior);

  if (atual === null || anterior === null || anterior === 0) return null;
  if (atual === anterior) return 0;

  return (atual - anterior) / Math.abs(anterior) * 100;
}

/** Formata a variacao com sinal, ex: "+3,3%" / "-12,5%". */
export function formatarVariacao(variacao) {
  if (variacao === null || variacao === undefined) return null;
  if (variacao === 0) return "igual";

  const casas = Math.abs(variacao) < 10 ? 1 : 0;
  const formatado = Math.abs(variacao).toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });

  return `${variacao > 0 ? "+" : "-"}${formatado}%`;
}
